module.exports = __webpack_public_path__ + "static/media/tutorial-dashboard2-step2.0e23ebde.png";